function identity<TValue>(i: TValue) {
  return i;
}

export function keyBy<TCollection>(
  collection: TCollection[],
  keyMapper: (value: TCollection, index: number) => string | number
): { [key: string]: TCollection };

export function keyBy<TCollection, TMappedValue>(
  collection: TCollection[],
  keyMapper: (value: TCollection, index: number) => string | number,
  valueMapper: (value: TCollection, index: number) => TMappedValue
): { [key: string]: TMappedValue };

export function keyBy<TCollection, TMappedValue>(
  collection: TCollection[],
  keyMapper: (value: TCollection, index: number) => string | number,
  valueMapper:
    | ((value: TCollection, index: number) => TCollection)
    | ((value: TCollection, index: number) => TMappedValue)
    | ((
        value: TCollection,
        index: number,
        currentValue?: TMappedValue
      ) => TMappedValue) = identity
) {
  return collection.reduce(
    (map, item, index) => {
      const key = keyMapper(item, index);

      map[key] = valueMapper(item, index, map[key] as TMappedValue | undefined);

      return map;
    },
    {} as { [key: string]: TCollection | TMappedValue }
  );
}
